/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const common = {
  viewAll: 'View all',
  start: 'Start',
  continue: 'Continue',
  completed: 'Completed',
  inProgress: 'In progress',
  notStarted: 'Not started',
  mandatory: 'Mandatory',
  optional: 'optional',
  minutes: 'Minute',
  points: 'points',
  cancel: 'Cancel',
  save: 'Save',
  submit: 'Send',
  close: 'Close',
  next: 'Next',
  previous: 'Previous',
  empty: 'No data',
  loading: 'Loading…',
  viewDetails: 'Show Details',
  download: 'Download',

  soon: 'Not available yet',
  accept: 'Agree',
  attachments: 'Attachments',
  comments: 'Comments',
  search: 'Search…',

  serial: 'ID',
  title: 'Title',
  mandatoryLabel: 'Mandatory',
  status: 'Enabled',
}

export const outcome = {
  passed: 'Passed',
  notPassed: 'Did Not Pass',
  notComplete: 'Not Completed',
}

export const shell = {
  courses: 'Programs',
  assessments: 'Assessment',
  surveys: 'Surveys',
  policies: 'Policies',
  reports: 'Security Reports',
  awareness: 'Awareness Content',
  leaderboard: 'Leaderboard',
  contact: 'Contact us',
  statistics: 'Dashboard',
  manual: 'User Manual',
  more: 'More',
  profile: 'Personal Profile',
  adminPanel: 'Admin panel',
  changePassword: 'Change Password',
  logout: 'Logout',
  notifications: 'Notifications',
  markAllRead: 'Mark all as read',
  copyright: 'All rights reserved',
}

/** See the note on `warnings` in strings.ar.js. */
export const warnings = {
  policies: 'There are new policies. Please agree to all policies that have not been acknowledged',
  surveys: 'There are mandatory surveys. Please open the surveys page and finish them',
  assessments: 'There are mandatory assessments. Please open the assessments page and finish them',
  go: 'Go',
  dismiss: 'Dismiss',
}

/** See the note on `gate` in strings.ar.js. */
export const gate = {
  policies: {
    title: 'Policies are waiting for your agreement',
    body: 'The portal stays closed until you have read the new policies and agreed to them.',
    action: 'Read and agree',
    one: 'A policy is waiting for your agreement',
    oneBody: 'The portal stays closed until you have read it and agreed to it.',
    manyBody: 'The portal stays closed until you have read and agreed to every one of them.',
    openOne: 'Read and agree',
  },
  assessments: {
    title: 'Mandatory assessments are not finished',
    body: 'The portal stays closed until you have completed the mandatory assessments.',
    action: 'Go to assessments',
    one: 'A mandatory assessment is not finished',
    oneBody: 'The portal stays closed until you have completed it.',
    manyBody: 'The portal stays closed until you have completed every one of them.',
    openOne: 'Open the assessment',
  },
  signOut: 'Sign out',
}

export const dashboard = {
  title: 'Dashboard',
  subtitle: 'A full view of your progress through programs and courses, with your points and badges.',
  programs: 'Programs',
  courses: 'Courses',
  watching: 'Watching Percentage',
  successRate: 'Success Percentage',
  positivePoints: 'Positive points',
  negativePoints: 'Negative points',
  riskLevel: 'Risk level',
  badges: 'Your badges',
  badgesEarned: 'Unlocked',
  badgesLocked: 'Locked',
  toUnlock: 'To unlock',
  continueLearning: 'Keep learning',
  rank: 'Rank',
  points: 'Points',

  greeting: 'Welcome back',
  standing: 'Your place on the board',
  todo: 'Waiting for you',
  todoEmpty: 'Nothing is waiting — you are all caught up',
  todoAssessments: 'Assessments open now',
  todoSurveys: 'Surveys awaiting your answer',
  todoPolicies: 'Policies awaiting your acknowledgement',
  todoExams: 'Exams ready to sit',
  todoCourses: 'Courses you have not finished',
  latestAwareness: 'Latest bulletins',
  nextBadge: 'Next badge',
}

export const courses = {
  availableFrom: 'Available from',
  title: 'Programs',
  subtitle: 'The training programs assigned to you — track your progress and collect your certificates.',
  filterAll: 'All',
  filterInProgress: 'In progress',
  filterCompleted: 'Completed',
  filterNotStarted: 'Not started',
  duration: 'Duration',
  chapters: 'Chapters',
  startCourse: 'Start now',
  continueCourse: 'Continue training',
  viewDetails: 'Show Details',
  viewCertificate: 'Download Certificate',
  exam: 'Final exam',
  summaryAvailable: 'Available Programs',
  summaryInProgress: 'Programs in progress',
  summaryCompleted: 'Completed programs',
  summaryCertificates: 'Available Certificates',
  noResults: 'No matching results',

  survey: 'Survey',
  certificate: 'Get certificate',
  sendCertificate: 'Sending by mail',
  finished: 'Watch Finished',
  started: 'Resume watching',
  notStarted: 'Did not start the course',
  notAttended: 'Exam not attended',
  noContent: 'No course nor exams found in the system, to be able to use the system you must create at least one course first and add an exam to it.',
  surveyRequired: 'Please fill the program survey to get the certificate',
  programCompleteRequired: 'You have to complete the program',
  programProgress: 'Progress Percentage',
  pdf: 'PDF',
  png: 'PNG',
}

export const courseDetails = {
  interactiveCourse: 'Interactive course',
  title: 'Course Details',
  content: 'Content',
  attachments: 'Attachments',
  downloadHint: 'Click on file name to download',
  videoCount: 'Video(s)',
  totalDuration: 'Total Duration',
  categoriesCount: 'Total Clips Count',
  contentType: 'Content Type',
  watchPercentage: 'Watching Percentage for Topics',
  courseStart: 'Course Starting Date',
  courseEnd: 'Course Ending Date',
  examTries: 'Exam Tries',
  examState: 'Exam State',
  examStateSuccess: 'Passed The Exam',
  examStateFail: 'Failed The Exam',
  examStateNotTaken: 'Exam Is Not Taken',
  startExam: 'Start Exam',
  examHistory: 'See your exam history',
  examModalTitle: 'Notification',

  examNavInstruction: 'Move between questions with the exam buttons.',
  examBackInstruction: 'Use the exam buttons to move between questions. Avoid closing or refreshing the page while taking the exam.',
  examStartDescription: 'You are about to start this course’s exam. Starting uses one attempt. Read the notes below, then select Start exam when you are ready.',
  completeWatch: 'You must watch all the content before taking the exam!',
  noExam: 'Course Has No Exam',
  triesCount: '{0} out of {1} tries',
  playlist: 'Content',
  topicComplete: 'Topic completed!',
  watchCompleted: 'You have completed this topic',
  topicsCompleted: 'You have watched all the content for this course',
  nextTopic: 'Go to next topic',
  openExam: 'Go to Exam',
  watchAgain: 'Watch the topic again',
  startContent: 'Start course',
  continueContent: 'Continue course',
  reviewContent: 'Review course',
  quizTitle: 'Quick quiz',
  quizInstruction: 'Answer every question to continue to the next topic.',
  subtitleToggle: 'Subtitles',
  mediaUnavailable: 'The video file could not be loaded. Please contact your administrator.',
}

export const exam = {
  elapsedTime: 'Elapsed time',
  title: 'Test',
  question: 'Question',
  counter: '{0} of {1}',
  finish: 'Finish',
  optionA: '(a)',
  optionB: '(b)',
  optionC: '(c)',
  optionD: '(d)',
  leaveWarning: 'You cannot go to another page while exam is running, please complete the exam or finish it.',

  rules: 'Once you begin you cannot pause the exam or return to it later. Answer every question, then press Finish.',
  start: 'Begin the exam',
  next: 'Next',
  back: 'Previous',
  sessionLostTitle: 'The exam session has ended',
  sessionLost:
    'This exam session is no longer available and cannot be resumed from where you stopped. You can begin again from the exam page.',
  backToStart: 'Back to the exam page',
  answerRequired: 'Choose an answer before continuing',
}

export const examHistory = {
  rawamExam: 'RAWAM exam results',
  title: 'Exams records',

  pickCourse: 'Choose a course to see its attempts',
  answersWithheld: 'The answer breakdown is not available for this attempt',
  examName: 'Exam Name',
  examDate: 'Exam Date',
  percentage: 'Degree',
  time: 'Total Time',
  result: 'Exam Status',
  detailsTitle: 'Exam details',
  correctAnswer: 'Correct Answer',
  noExams: 'There are no previous exams in this course',
  emptyData: 'There are no exam to display.',
  passedMessage: 'You have passed the exam',
  notPassedMessage: 'You have not passed the exam',
}

export const awareness = {
  title: 'Awareness Content',
  subtitle: 'Articles and resources to sharpen your security awareness',
  readMore: 'Read more',
  attachments: 'Attachments',
  noContent: 'No Content Available',
}

export const policies = {
  title: 'Policies',
  subtitle: 'Read the policies and acknowledge them',
  acceptedOn: 'Accepted on',
  preview: 'Preview document',
  acceptPolicy: 'Acknowledge policy',

  version: 'Version',
  accept: 'Acknowledge',
  accepted: 'Acknowledged',
  alreadyAccepted: 'Already acknowledged',
  notAccepted: 'Not acknowledged',
  rejected: 'Rejected',
  states: { accepted: 'Acknowledged', pending: 'Awaiting acknowledgement', rejected: 'Rejected' },
  viewed: 'Viewed',
  notViewed: 'Not Viewed',
  downloaded: 'File downloaded',
  notDownloaded: 'File not downloaded',
  uncategorized: 'Uncategorized',
  documentMissing: 'The policy document could not be opened',
  documentMissingHint: 'The file is not on the server. Contact an administrator before approving.',
  noContent: 'No Content Available',
}

export const assessments = {
  title: 'Assessment',
  subtitle: 'Measure where you stand and see what to improve',
  start: 'Start assessment',
  history: 'Attempt history',
  open: 'Available now',

  done: 'You have completed this assessment',
  earlyStart: 'This Assessment did not started yet',
  finished: 'This Assessment is now finished',
  notActive: 'The selected Assessment is not active',

  period: 'Assessment period',
  about: 'About this assessment',
  before: 'Before you start',
  once: 'An assessment counts once and cannot be retaken after you finish it.',
  all: 'All assessments',
}

export const surveys = {
  title: 'Surveys',
  subtitle: 'Share your view in a minute',
  start: 'Fill in the survey',
  thankYou: 'Thank you for taking part!',
  statusAvailable: 'Open for responses',
  statusCompleted: 'Your response was sent',
  type: 'Type',
  typeGeneral: 'General',
  typeCourse: 'Course',
  typeProgram: 'Program',

  submit: 'Finish',
  answerYes: 'Yes',
  answerNo: 'No',
  resetStars: 'Reset',
  textPlaceholder: 'Write You Answer Here',

  missingAnswers: 'Answer every required question, then try again.',
  missingShort: 'Required questions left blank',
  saved: 'Answers were added successfully',
  noQuestions: 'This survey does not have any questions',

  backInstruction: 'Do not use the browser\'s back button or refresh the page — you will lose your answers.',

  answeredOf: 'Answered',
  questionsNav: 'Questions',

  questionOne: '1 question',
  questionTwo: '2 questions',
  questionFew: 'questions',
  questionMany: 'questions',
}

export const reports = {
  reporter: 'Reported by',
  details: 'Report details',
  thread: 'Conversation',
  closedNotice: 'This report is closed; no more comments can be added.',
  noComments: 'No comments yet. The response team will reply here.',
  backToList: 'All reports',
  title: 'Security Reports',
  subtitle: 'Report any security incident or suspicion',
  create: 'New Report',
  subject: 'Report Title',
  status: 'Report State',
  created: 'Report Date',
  lastUpdate: 'Last Updated',
  number: 'Report Number',
  category: 'Report Category',
  subCategory: 'Report Sub Category',
  content: 'Report content',
  attachments: 'Attachments',
  attachmentsHint: 'PNG · JPG · GIF · DOC · DOCX · PDF',
  commentAdd: 'Add a comment',
  commentPlaceholder: 'Write your comment here…',
  commentSend: 'Send comment',
  formIntro: 'Fill in the details carefully so the response team can act quickly.',
  selectCategory: 'Choose a category',
  selectSubCategory: 'Choose a sub-category',

  sent: 'Report sent',
  commentSent: 'The comment was added',

  titleLength: 'The report title should be between 3 and 200 letters',
  contentLength: 'Input should be between 3 and 2000 letters',
  commentLength: 'Input should be between 2 and 1500 letters',

  stateNew: 'New',
  stateInProgress: 'In Progress',
  stateClosed: 'Completed',
}

export const leaderboard = {
  title: 'Leaderboard',
  subtitle: 'Employees ranked by the points they earn for taking part in cyber awareness.',
  username: 'Username',
  name: 'Name',
  department: 'Group',
  points: 'Points',
  badges: 'Badges',
  rank: 'Rank',
  search: 'Search the leaderboard…',
  you: 'You',
  podium: 'Podium',
  totalPlayers: 'Total players',
  topScore: 'Top score',
  avgScore: 'Average score',
  allDepts: 'All departments',
}

export const profile = {
  title: 'Personal Profile',
  subtitle: 'Your personal and work details on Rawam.',
  email: 'Email',
  phone: 'Phone',
  mobile: 'Mobile',
  department: 'Group',
  username: 'Username',
  employeeId: 'Employee ID',
  arabicName: 'Arabic Name',
  englishName: 'English Name',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  account: 'Account details',
  personal: 'Personal details',
  work: 'Work details',
  save: 'Save changes',
  saved: 'Your changes were saved',
  /* Every field hidden by the client's profile field setup — nothing left to fill in. */
  noFields: 'No profile fields are available to edit',

  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmPassword: 'Confirm Password',

  passwordChanged: 'Password Changed Successfully',
  passwordFailed:
    'Operation Failed maybe current password is wrong, password should contains 8 chars min and on capital letter, one symbol and a number',

  nameNote:
    'Your name appears on the certificate exactly as you type it here, so make sure it reads the way you want it to.',
  language: 'Preferred Language',
  arabic: 'Arabic',
  english: 'English',
  startDate: 'Start Date',
}

export const contact = {
  title: 'Contact us',
  subtitle: 'The support team is here to help',
  send: 'Send message',

  messageTitle: 'Message Title',
  messageContent: 'Message Subject',
  emailLabel: 'Support Email',
  phoneLabel: 'Support Phone',
  titleInvalid: 'Input must be between 2 and 200 characters',
  contentInvalid: 'Input must be between 2 and 2000 characters',
}

export const certificates = {
  title: 'Certificate of completion',
  eyebrow: 'Accredited certificate',
  issuedOn: 'Issue Date',

  subtitle:
    'Download the certificate for a program you have passed. Note: you must pass every course inside the program before the certificate becomes available',
  programDetails: 'Users Performance',
  courseName: 'Course name',
  watchState: 'Watch State',
  examState: 'Exam State',
  examTries: 'Exam Tries',
  start: 'Home',
  end: 'End Date',
  noContent:
    'No learning programs found in the system, in order to use this page there must be at least one learning program available',
}

export const manual = {
  title: 'User Manual',
  subtitle: 'Everything you need to know about using the platform',
  pdf: 'PDF document',
  video: 'Video',
  updated: 'Updated',
  openInTab: 'Open in new tab',
  emptyTitle: 'No user manual yet',
  emptyBody: "Your organization hasn't published one yet. It will appear here as soon as it does.",
  upload: 'Upload it in settings',
}

export const terms = {
  title: 'Terms of Use',
  subtitle:
    'You must agree to the Terms of Use in order to proceed and use the system. Please read carefully and then click the accept button.',
  agree: 'Accept',
  logout: 'Logout',

  updated: 'تم تحديث شروط الاستخدام، فضلا قم بمراجعتها والموافقة عليها للمتابعة.' /* !! */,

  failed: 'تعذر حفظ ردك، فضلا حاول مرة أخرى.' /* !! */,
}
